export default {
  'menu.AttendanceRecordListPage': '打卡历史',

  'app.attendanceRecord.attr.signInType.enum.sign_in_at_work': '上班签到',
  'app.attendanceRecord.attr.signInType.enum.sign_in_after_get_off_work': '下班签退',
}